import SgdfTableFilter from './table-filter.component.js';
export * from './table-filter.component.js';
export default SgdfTableFilter;
SgdfTableFilter.define('sgdf-table-filter');
//# sourceMappingURL=table-filter.js.map